import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "types/table/TableColumn";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import { FiltrosTabela } from "types/table/FiltrosTabela";
import { RenderRowsCobrancasEmAbertoProcessoJudicial } from "./RenderRowsCobrancasEmAbertoProcessoJudicial";
import React, { useEffect, useState } from "react";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";
import { RegistroContaReceberDTO } from "types/dto/RegistroContaReceberDTO";

interface TabelaModalSelecionarCobrancasProcessoJudicialProps {
  isLoading: boolean;
}
const TabelaModalSelecionarCobrancasProcessoJudicial: React.FC<TabelaModalSelecionarCobrancasProcessoJudicialProps> = (
  props
) => {
  const [isCheckBoxChecked, setIsCheckBoxChecked] = useState<boolean>(false);
  const {
    filtroTabelaSelecionarCobranca: filtro,
    setFiltroTabelaSelecionarCobranca,
    registrosTabelaModalSelecionarCobrancas: cobrancasPage,
    cobrancasModalSelecionadas: cobrancasSelecionadas,
    setCobrancasModalSelecionadas: setCobrancasSelecionadas,
    idsCobrancasModalSelecionadas: idsCobrancasSelecionadas,
    setIdsCobrancasModalSelecionadas: setIdsCobrancasSelecionadas,
    opcaoCheckBoxSelecionarCobrancasModal: valueCheckBox,
    setOpcaoCheckBoxSelecionarCobrancasModal: setValueCheckBox,
  } = useProcessosJudiciaisContext();

  useEffect(() => {
    if (
      !(valueCheckBox === "TODAS_FILTRO") &&
      !props.isLoading &&
      cobrancasPage?.content &&
      cobrancasPage.content.length > 0
    ) {
      if (isTodosRegistrosDaPaginaSelecionados()) {
        setValueCheckBox("TODAS_PAGINA");
        setIsCheckBoxChecked(true);
      } else {
        setValueCheckBox("NENHUMA");
        setIsCheckBoxChecked(false);
      }
    }
  }, [cobrancasPage?.content, idsCobrancasSelecionadas]);

  const isTodosRegistrosDaPaginaSelecionados = () => {
    let idsCobrancasPagina = cobrancasPage?.content.map((cobranca) => cobranca.id) || [];
    return idsCobrancasPagina.every((id) => idsCobrancasSelecionadas.includes(id));
  };

  const createColumnsInadimplencia = (): TableColumn[] => {
    return [
      {
        id: "mesCompetencia",
        label: "Competência",
        isOrdenavel: true,
      },
      {
        id: "nossoNumero,dataVencimento",
        label: "Nosso número",
        isOrdenavel: true,
      },
      {
        id: "dataVencimento",
        label: "Vencimento",
        isOrdenavel: true,
      },
      {
        id: "total",
        label: "Valor (R$)",
        width: "150px",
      },
      {
        id: "acoes",
        label: "",
        width: "80px",
      },
    ];
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao =
      !filtro?.ordenacaoAscOuDesc || filtro.ordenarPorColuna !== idColuna || filtro.ordenacaoAscOuDesc === "DESC"
        ? "ASC"
        : "DESC";
    let novoFiltro = {
      ...filtro,
      ordenacaoAscOuDesc: novaOrdenacao,
      ordenarPorColuna: idColuna,
      sortString: `${idColuna},${novaOrdenacao}`,
    } as FiltrosTabela;
    setFiltroTabelaSelecionarCobranca(novoFiltro);
  };

  const changeCheckBox = (opcao: OpcoesSelecionaveisCheckBox) => {
    if (opcao === "TODAS_FILTRO") {
      setIdsCobrancasSelecionadas([]);
      setCobrancasSelecionadas([]);
      setIsCheckBoxChecked(true);
    } else if (opcao === "TODAS_PAGINA" && !(valueCheckBox === "TODAS_PAGINA")) {
      let cobrancasPagina = cobrancasPage?.content || [];
      let novasCobrancasSelecionadas = [...cobrancasSelecionadas, ...cobrancasPagina];
      let novosIdsCobrancasSelecionadas = novasCobrancasSelecionadas.map((cobranca) => cobranca.id);
      setCobrancasSelecionadas(novasCobrancasSelecionadas);
      setIdsCobrancasSelecionadas(novosIdsCobrancasSelecionadas);
      setIsCheckBoxChecked(true);
    } else if (opcao === "NENHUMA") {
      setIdsCobrancasSelecionadas([]);
      setCobrancasSelecionadas([]);
      setIsCheckBoxChecked(false);
    }
    setValueCheckBox(opcao);
  };

  const onSelecionarCobranca = (cobranca: RegistroContaReceberDTO) => {
    let idsCobrancas = [...idsCobrancasSelecionadas, cobranca.id];
    let cobrancas = [...cobrancasSelecionadas, cobranca];

    setCobrancasSelecionadas(cobrancas);
    setIdsCobrancasSelecionadas(idsCobrancas);
  };
  const onDesmarcarCobranca = (cobranca: RegistroContaReceberDTO) => {
    let idsCobrancas = idsCobrancasSelecionadas.filter((id) => id !== cobranca.id);
    let cobrancas = cobrancasSelecionadas.filter((cobrancaSelecionada) => cobrancaSelecionada.id !== cobranca.id);

    setCobrancasSelecionadas(cobrancas);
    setIdsCobrancasSelecionadas(idsCobrancas);
    setIsCheckBoxChecked(false);
  };

  const onChangePage = (paginaAtual: number) => {
    if (paginaAtual !== filtro.paginaAtual) {
      setFiltroTabelaSelecionarCobranca({ ...filtro, paginaAtual: paginaAtual });
    }
  };

  return (
    <Tabela
      id="tabela-cobrancas-em-aberto-processo-judicial"
      colunas={createColumnsInadimplencia()}
      ordernarPorColuna={filtro?.ordenarPorColuna || ""}
      ordenacaoAscOuDesc={filtro?.ordenacaoAscOuDesc || "ASC"}
      ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
      onChangePageFunction={onChangePage}
      paginaAtual={filtro?.paginaAtual || 1}
      quantidadeDePaginas={cobrancasPage?.totalPages || 0}
      quantidadeDeRegistros={cobrancasPage?.totalElements || 0}
      renderCheckBox
      onChangeCheckBox={(value: OpcoesSelecionaveisCheckBox) => changeCheckBox(value)}
      tipoCheckBox={"SELECT_OPTIONS"}
      isLoading={props.isLoading}
      checkedCheckBox={props.isLoading ? false : isCheckBoxChecked}
    >
      <RenderRowsCobrancasEmAbertoProcessoJudicial
        opcaoSelecionadaCheckBox={valueCheckBox}
        idsCobrancasSelecionadas={idsCobrancasSelecionadas}
        onSelecionarCobranca={(cobranca: RegistroContaReceberDTO) => onSelecionarCobranca(cobranca)}
        onDesmarcarCobranca={(cobranca: RegistroContaReceberDTO) => onDesmarcarCobranca(cobranca)}
      />
    </Tabela>
  );
};

export default TabelaModalSelecionarCobrancasProcessoJudicial;
